export default __webpack_public_path__ + "static/media/LuckyBlue.d2a3db25.png";